import React, { Component } from 'react'
import { fabric } from 'fabric'
import { Button } from 'react-bootstrap'
import { withDimensions, getHeightFromAspectRatio } from './helpers'
import { FabricShape, DrawPolygon, DrawArrow } from './components/FabricShape'
import InputFloatingComment from './components/InputFloatingComment'
import { CameraActions, AnnotateActions } from './components/VideoActions'
import EvaluationVideoPlayer from './components/EvaluationVideoPlayer'
import OverlayCard from './components/OverlayCard'
import tinycolor from 'tinycolor2'

import { ReactComponent as ShareIcon } from '../../../../assets/svg/actions/icn-share-16px.svg'
import { ReactComponent as CloseIcon } from '../../../../assets/svg/actions/icn-close.svg'
import THUMBNAIL from '../../../../assets/img/demo/video-player-evaluation.jpg'

class VideoPlayerAnnotations extends Component {
    constructor(props) {
        super(props)

        this.state = {
            videoState: '',
            videoTime: 0,
            shapeOptions: {
                fillColor: tinycolor("#FFCA41").setAlpha(.5),
                strokeColor: "#FFFFFF",
            },
            selectedShape: '',
            activeType: '',
            shapes: [],
            videoMarkers: []
        }

        this.cursors = {
            default: 'no-drop',
            draw: 'crosshair'
        }
    }

    timeRound = Math.floor

    handleVideoStateChange = (state, currentTime) => {
        this.setState({ videoState: state, videoTime: currentTime });
    }

    handleVideoTimeUpdate = (currentTime) => {
        this.setState({ videoTime: currentTime });
        this.canvas.discardActiveObject();

        // Add shapes from state to their proper time
        this.state.shapes.map(activeObj => {
            if (this.timeRound(activeObj.time) === this.timeRound(currentTime)) {
                const isExist = this.canvas.getObjects().filter(shape => shape.id === activeObj.id).length;
                if (!isExist) this.canvas.add(activeObj);
            } else {
                this.canvas.remove(activeObj);
            }
        })
    }

    createShape = (type) => {
        // Object is created put not drawn yet
        let shapeOptions = {}
        console.log(type);
        this.canvas.discardActiveObject();
        this.setState({ activeType: type });
        this.canvas.defaultCursor = this.cursors.draw;

        if (type === 'line') {
            shapeOptions = {
                fillColor: 'rgba(255, 202, 65, 0.5)',
                strokeColor: '#FFFFFF',
                time: this.state.videoTime,
                ...this.state.shapeOptions
            }

            new DrawPolygon(this.canvas, shapeOptions, {
                selected: this.handleObjectSelect,
                created: this.handleObjectCreated
            });
        } else if (type === 'arrow') {
            shapeOptions = {
                fillColor: 'rgba(255, 202, 65, 0.5)',
                strokeColor: '#FFFFFF',
                time: this.state.videoTime,
                isDrawing: true,
                ...this.state.shapeOptions
            }

            new DrawArrow(this.canvas, shapeOptions, {
                selected: this.handleObjectSelect,
                created: this.handleObjectCreated
            });
        } else if (type === 'rect' || type === 'circle') {
            shapeOptions = {
                type,
                isDrawing: true,
                class: 'shape',
                fillColor: 'rgba(255, 202, 65, 0.5)',
                strokeColor: '#FFFFFF',
                time: this.state.videoTime,
                ...this.state.shapeOptions
            }

            new FabricShape(this.canvas, shapeOptions, {
                selected: this.handleObjectSelect,
                created: this.handleObjectCreated
            });
        }

    }

    handleObjectSelect = (o) => {
        const selectedShape = o.target;
        console.log('selected', o.target, this.state.activeType);

        this.setState({
            selectedShape,
            activeType: ''
        });
    }

    handleObjectCreated = (o) => {
        // Object is drawn to the view
        const selectedShape = o.target;
        console.log('created', o.target, this.state.activeType);
        this.canvas.defaultCursor = this.cursors.default;
        
        const isExist = this.state.shapes.filter(shape => shape.id === selectedShape.id).length;
        if (selectedShape && !isExist) {

            this.setState(prevState => ({
                activeType: '',
                shapes: [
                    ...prevState.shapes,
                    selectedShape
                ],
                videoMarkers: [
                    ...prevState.videoMarkers,
                    {time: prevState.videoTime, text: selectedShape.comment || '', id: selectedShape.id}
                ]
            }));
        }
    }

    handleDeleteShape = () => {
        this.canvas.getActiveObjects().map(activeObj => {
            this.canvas.remove(activeObj);
            this.setState(prevState => ({ 
                shapes: prevState.shapes.filter(stateShape => stateShape.id !== activeObj.id),
                videoMarkers: prevState.videoMarkers.filter(stateMark => stateMark.id !== activeObj.id),
            }));
        });

        this.canvas.discardActiveObject();

        this.setState({
            selectedShape: '',
            activeType: ''
        });
    }

    updateShapeColors = (e, type = 'fill') => {
        const inputValue = e.target.value;
        const selectedShape = this.canvas.getActiveObject();
        let color = type === 'fill' ? tinycolor(inputValue).setAlpha(.5) : inputValue;
        selectedShape.set(type, color);
        this.canvas.add(selectedShape);
        this.setState(prev => ({
            shapeOptions: {
                ...prev.shapeOptions,
                fillColor: type === 'fill' ? color : prev.shapeOptions.fillColor,
                strokeColor: type === 'stroke' ? color : prev.shapeOptions.strokeColor,
            }
        }))
    }

    createComment = () => {
        this.setState({ activeType: 'comment' });
    }

    handleCommentChange = (e, shape) => {
        const inputValue = e.target.value;
        const activeObj = this.canvas.getActiveObject();
        // const isExist = this.state.shapes.filter(shape => shape.id === selectedShape.id).length;

        shape.comment = inputValue;
        // If the active shape is the same as the comment shape
        if (activeObj && activeObj.id === shape.id) {

            // check if the comment is already exist in the active shape
            if (activeObj.comment !== shape.comment) {
                // update the shape in the state
                this.setState(prevState => prevState.shapes.map(stateShape => stateShape.id === shape.id ? shape : stateShape))
                this.canvas.add(shape);
                this.canvas.remove(activeObj);
            }
        }
    }

    handleInsertAction = (metricKey) => {
        // TAKE SNAPSHOT FROM VIDEO

        const video = document.getElementById('playerEvaluationVideo_html5_api');
        const canvas = this.canvas.getElement();

        // create context to take the snapshot
        const context = canvas.getContext('2d');
        const width = this.props.width;
        const height = getHeightFromAspectRatio(width);
        const scaleX = width / canvas.width;
        const scaleY =  height / canvas.height;
        
        // Draw canvas image
        // context.fillRect(0, 0, width, height + 48);
        context.drawImage(
            video,
            0,
            0,
            width * scaleX,
            height * scaleY
        );

        // Get snapshot without shapes
        const imgBase64WithoutShapes = canvas.toDataURL();

        // Make the snapshot background for fabric
        new fabric.Image.fromURL(imgBase64WithoutShapes, fabricImage => {

            this.canvas.setBackgroundImage(fabricImage, bgImg => {

                // Get snapshot with shapes
                const imgBase64 = this.canvas.toDataURL();

                // Remove the snap background from canvas
                this.canvas.setBackgroundImage(0).renderAll();

                // Insert the image with the proper metric
                const insertedImage = {
                    metric: metricKey,
                    source: imgBase64
                }

                this.props.onImageInsert(insertedImage);
            });
        });
    }

    hideCanvase = () => {
        this.setState({ videoState: ' ' });
    }

    componentDidMount() {
        this.canvas = new fabric.Canvas('annotateVideo', {
            selection: false,
            defaultCursor: this.cursors.default
        });
    }

    componentWillReceiveProps(nextProps) {
        // Update initial canvas width
        if (nextProps.width !== this.props.width) {
            console.log('canvas size updated');

            this.canvas.setWidth(nextProps.width);
            // height - 48 (the video controller height)
            this.canvas.setHeight(getHeightFromAspectRatio(nextProps.width));
        }

    }

    render() {
        return (
            <div className="center-content">
                <div id="video-annotate-contianer" style={{ position: 'relative' }}>
                    {this.renderVideoOverlay()}
                    {this.renderVideoPlayer()}
                    {this.renderCanvas()}
                    {this.renderComments()}
                </div>
                {this.renderActions()}
            </div>
        )
    }

    renderVideoPlayer() {
        return (
            <EvaluationVideoPlayer
                src={'/videos/match.mp4'}
                thumbnail={THUMBNAIL}
                onVideoStateChange={this.handleVideoStateChange}
                onTimeUpdate={this.handleVideoTimeUpdate}
                markers={this.state.videoMarkers}
            />
        )
    }

    renderCanvas() {
        const isPaused = this.state.videoState === 'pause';

        return (
            <div className="video-annotate-canvas" hidden={!isPaused}>
                <canvas id="annotateVideo">
                    <p>Unfortunately, your browser is currently unsupported by our web application. We are sorry for the inconvenience. Please use one of the supported browsers listed below, or draw the image you want using an offline tool.</p>
                    <p>Supported browsers: <a href="https://www.opera.com">Opera</a>, <a href="http://www.mozilla.com">Firefox</a>, <a href="http://www.apple.com/safari">Safari</a>, and <a href="http://www.konqueror.org">Konqueror</a>.</p>
                </canvas>
                <Button variant="dark" className="share-video-btn close-btn" onClick={() => this.hideCanvase()}>
                    <CloseIcon />
                </Button>
            </div>
        )
    }

    renderComments() {
        // Render a comment for each shape in the canvas
        return this.state.shapes.map((shapeObj, index) => {
            const { selectedShape, activeType } = this.state;

            const isHidden = !selectedShape
                || !activeType
                || activeType !== 'comment'
                || shapeObj.id !== selectedShape.id
                || this.timeRound(shapeObj.time) !== this.timeRound(this.state.videoTime);

            return (
                <InputFloatingComment
                    key={index}
                    onChange={e => this.handleCommentChange(e, shapeObj)}
                    hidden={isHidden}
                    position={{
                        top: shapeObj ? shapeObj.top + shapeObj.height + 10 : 'auto',
                        left: shapeObj ? shapeObj.left : 'auto'
                    }}
                />
            )
        })
    }

    renderActions() {
        const isPaused = this.state.videoState === 'pause';

        return (
            <div className="d-flex">
                <CameraActions />
                <AnnotateActions
                    disabled={!isPaused}
                    square={{
                        active: this.state.activeType === 'rect',
                        onClick: () => this.createShape('rect')
                    }}
                    circle={{
                        active: this.state.activeType === 'circle',
                        onClick: () => this.createShape('circle')
                    }}
                    line={{
                        active: this.state.activeType === 'line',
                        onClick: () => this.createShape('line')
                    }}
                    arrow={{
                        active: this.state.activeType === 'arrow',
                        onClick: () => this.createShape('arrow')
                    }}
                    comment={{
                        active: this.state.activeType === 'comment',
                        disabled: this.canvas ? !this.canvas.getActiveObject() : true,
                        onClick: () => this.createComment()
                    }}
                    insertObj={{
                        disabled: !this.state.selectedShape,
                        onClick: this.handleInsertAction,
                        title: "Select metric to insert the edited image",
                        items: [
                            'Crossing Accuracy',
                            'Finishing Accuracy',
                            'Heading Accuracy',
                            'Short Passing',
                            'Volleys'
                        ],
                    }}
                    deleteObj={{
                        disabled: !this.state.selectedShape,
                        onClick: () => this.handleDeleteShape()
                    }}
                    colors={{
                        show: this.state.selectedShape,
                        fillColor: this.state.shapeOptions.fillColor.getOriginalInput(),
                        strokeColor: this.state.shapeOptions.strokeColor,
                        onChangeFill: e => this.updateShapeColors(e, 'fill'),
                        onChangeStroke: e => this.updateShapeColors(e, 'stroke'),
                    }}
                />
            </div>
        )
    }

    renderVideoOverlay() {
        const isInit = this.state.videoState === '';

        return (
            <div hidden={!isInit}>
                <OverlayCard
                    title="Team A VS Team B"
                    subtitle="Goals 2-0"
                    text="12/31/2019 6:00PM | Goodison Park"
                >
                    <span className="overlay-background"></span>
                </OverlayCard>
                <Button variant="dark" className="share-video-btn" onClick={() => this.props.onShareVideoClicked('videoUrl')}>
                    <ShareIcon />
                </Button>
            </div>
        )
    }
}

export default withDimensions(VideoPlayerAnnotations);